	jQuery(document).ready(function($){
		$('a.add_to_cart_button').removeAttr('rel');
      
      
      if ($(window).width() < 991) {
        $('.level-one span').on('click', function(event) {              				
          event.stopPropagation();                   
          $(this).parent().toggleClass('open'); 
		});
      }
      
	});
	(function($){
		$(document).ready(function(){
		    $('ul.dropdown-menu [data-toggle="dropdown"]').on('click', function(event) {
		        event.preventDefault(); 
		        event.stopPropagation(); 
		        $(this).parent().siblings().removeClass('open');
		        $(this).parent().toggleClass('open');
		    });
          	
// 		    if($(window).width() < 768) {
// 			     $('.site-nav--has-submenu > a').on('click', function(event) {
// 			        event.preventDefault(); 
// 			        event.stopPropagation(); 
// 			        $(this).siblings('span').trigger('click');
// 			    });
// 			 }
		}); 
		//Pop Up
		$(document).ready(function ()
{
  //Fade in delay for the background overlay (control timing here)
	$("#bkgOverlay").delay(1200).fadeIn(400);
  //Fade in delay for the popup (control timing here)
	$("#delayedPopup").delay(1200).fadeIn(400);
	
	//Hide dialouge and background when the user clicks the close button
	$("#btnClose").click(function (e)
	{
		HideDialog();
		e.preventDefault();
	});
  	$(".backgroundOverlay").click(function (e)
	{
		HideDialog();
		e.preventDefault();
	});
          
          $('.submenu-first').click(function(){
          	var url = $(this).attr('data-href');
            window.location = url;
          });
          $('#RecoverPassword').click(function(){
              $('#RecoverPasswordForm').removeClass('hide');                                    
          });
           $('#HideRecoverPasswordLink').click(function(){
              $('#RecoverPasswordForm').addClass('hide');                                    
          });
          
	
});
//Controls how the modal popup is closed with the close button
function HideDialog()
{
	$("#bkgOverlay").fadeOut(400);
	$("#delayedPopup").fadeOut(300);
}

	})(jQuery);

jQuery(document).ready(function() { 
  
  
var sync1 = jQuery("#sync1");
    var sync2 = jQuery("#sync2");
    var slidesPerPage = 4; //globaly define number of elements per page
    var syncedSecondary = true;

    sync1
      .owlCarousel({
      items: 1,
      slideSpeed: 3000,
      nav: true,     	
      autoplayHoverPause: true,
//       autoplayTimeout: 2000,
      autoplaySpeed: 3000, 
      smartSpeed: 3000,
      dots: false,
      loop: true,    
//       autoHeight: true,
      responsiveClass: true,
      responsive: {
        0: {
          item: 1,
          autoplay: false
        },
        600: {
          items: 1,
          autoplay: true
        }
      },
      responsiveRefreshRate: 200,
      navText: [
        '<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>',
        '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width: 1px;stroke: #000;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'
      ]
    })
      .on("changed.owl.carousel", syncPosition);

    sync2
      .on("initialized.owl.carousel", function() {
      sync2
        .find(".owl-item")
        .eq(0)
        .addClass("current");
    })
      .owlCarousel({
      items: slidesPerPage,
      dots: true,
      //   nav: true,
      smartSpeed: 1000,
      slideSpeed: 1000,
      slideBy: slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
      responsiveRefreshRate: 100
    })
      .on("changed.owl.carousel", syncPosition2);

    function syncPosition(el) {
      //if you set loop to false, you have to restore this next line
      //var current = el.item.index;

      //if you disable loop you have to comment this block
      var count = el.item.count - 1;
      var current = Math.round(el.item.index - el.item.count / 2 - 0.5);

      if (current < 0) {
        current = count;
      }
      if (current > count) {
        current = 0;
      }

      //end block

      sync2
        .find(".owl-item")
        .removeClass("current")
        .eq(current)
        .addClass("current");
      var onscreen = sync2.find(".owl-item.active").length - 1;
      var start = sync2
      .find(".owl-item.active")
      .first()
      .index();
      var end = sync2
      .find(".owl-item.active")
      .last()
      .index();

      if (current > end) {
        sync2.data("owl.carousel").to(current, 100, true);
      }
      if (current < start) {
        sync2.data("owl.carousel").to(current - onscreen, 100, true);
      }
    }

    function syncPosition2(el) {
      if (syncedSecondary) {
        var number = el.item.index;
        sync1.data("owl.carousel").to(number, 1000, true);
      }
    }

    sync2.on("click", ".owl-item", function(e) {
      e.preventDefault();
      var number = jQuery(this).index();
      sync1.data("owl.carousel").to(number, 3000, true);
    });
  });
